<div layout="column">
  <div [ngClass]="!clientData ? 'edit-screen-header' : 'credit-client-edit-header'"
       flex>
    @if (!isNewItem && !clientData) {
    <span class="edit-screen-title"
          layout="row"
          layout-align="start"
          flex>
      <itfg-brand-logo [brand]="this.client.brand"></itfg-brand-logo>
      <span flex>{{ client | clientFullName }}</span>
    </span>
    }
    @if (isNewItem) {
    <span class="edit-screen-title"
          layout="row"
          flex>
      <span flex>{{ 'clients.createNewClient' | translate }}</span>
    </span>
    }
    <div flex="100"
         layout="row"
         layout-wrap
         layout-align="start">
      <div flex
           layout="row"
           layout-wrap>
        <div>
          <itfg-status-data-edit (statusDataChanged)="statusDataChanged($event)"
                                 [clientId]="client?.id"
                                 [clientStatuses]="clientStatuses"
                                 [statusEditData]="this.client.status"></itfg-status-data-edit>
        </div>

        <itfg-tag-chips *ngxPermissionsOnly="'TAG_READ'"
                        [inputId]="client?.id"
                        [inputTags]="client?.tags"
                        [tagTypeName]="tagTypeNames.CLIENT"></itfg-tag-chips>
      </div>
      <div layout="row"
           layout-align="end center"
           flex="nogrow">
        @if ((isClientInput || client?.id) && clientOffers?.length > 0) {
        @let currentClient = isClientInput ? clientData : client;
        @let offersTooltipText = 'clientPricingOffers.clientHasOffers' | translate: {
        offersStatus: (
        activeClientOffers?.length === 0 ? ('clientPricingOffers.noActiveOffers' | translate) :
        activeClientOffers?.length === 1 ? ('clientPricingOffers.oneActiveOffer' | translate) :
        ('clientPricingOffers.multipleActiveOffers' | translate: {count: activeClientOffers?.length})
        )
        };

        <a mat-icon-button
           matTooltipPosition="below"
           [matTooltip]="offersTooltipText"
           class="mat-elevation-z2 margin-right-10px"
           [disabled]="['CLIENT_PRICING_OFFER_READ'] | isUnauthorized | async"
           *ngxPermissionsOnly="'CLIENT_PRICING_OFFER_READ'"
           routerLink="/clients/pricing-offers"
           [queryParams]="{ civilId: currentClient?.civilId, brandCode: currentClient?.brand?.code }"
           target="_blank">
          <mat-icon [matBadge]="activeClientOffers?.length"
                    matBadgeColor="accent"
                    matBadgeSize="small"
                    matBadgePosition="after"
                    [matBadgeHidden]="activeClientOffers?.length === 0"
                    svgIcon="GRAY_PRICE_TAG"></mat-icon>
        </a>
        }
        <button mat-icon-button
                matTooltipPosition="below"
                matTooltip="{{
              (client?.tags?.length < TAGS_LIMIT
                ? 'clients.addClientTag'
                : 'credits.addTagLimitReached'
              ) | translate: { tagsLimit: TAGS_LIMIT }
            }}"
                class="mat-elevation-z2 margin-right-10px"
                [disabled]="client?.tags?.length >= TAGS_LIMIT"
                *ngxPermissionsOnly="'TAG_WRITE'"
                #tagMenuTrigger="matMenuTrigger"
                [matMenuTriggerFor]="tagMenu"
                (menuOpened)="focusTagSearchBarInput()">
          <mat-icon [style.color]="'gray'"
                    matPrefix> label </mat-icon>
        </button>

        <mat-menu #tagMenu="matMenu"
                  class="tag-menu">
          <itfg-tags-dropdown #tagMenuComponent
                              [entityId]="client.id"
                              [appliedTags]="client?.tags"
                              [tagLimit]="TAGS_LIMIT"
                              [menuTrigger]="tagMenuTrigger"
                              (onTagSelected)="handleTagSelection($event)"></itfg-tags-dropdown>
        </mat-menu>
        <a [routerLink]="['/credits/applications', applicationId]"
           target="_blank"
           matTooltip="{{ 'applications.redirectToApplication' | translate }}"
           matTooltipPosition="below">
          @if (!client.id && applicationId) {
          <button mat-icon-button
                  class="margin-right-10px mat-elevation-z2">
            <mat-icon>request_quote </mat-icon>
          </button>
          }
        </a>
        @if (!isNewItem) {
        <button mat-icon-button
                class="mat-elevation-z2 margin-right-10px"
                [ngStyle]="{
            color: !client?.loyaltyEnabled
              ? 'grey'
              : loyaltyPointsAvailableNumber >= 0
                ? 'green'
                : 'red',
          }"
                [disabled]="false"
                (click)="openLoyaltyPointsDetails()"
                matTooltip="{{
            (client?.loyaltyEnabled
              ? 'clients.loyaltyEnabled'
              : 'clients.loyaltyDisabled'
            ) | translate
          }}">
          <b>{{ loyaltyPointsAvailableNumber
            }}{{ 'clients.pointsShort' | translate }}</b>
        </button>
        }
        <button mat-raised-button
                [disabled]="!enableSaveButton || !clientDataChangesDetected"
                (click)="save()"
                class="button-padding"
                [ngClass]="{
            'changes-detected': enableSaveButton && clientDataChangesDetected,
          }">
          {{ 'global.save' | translate }}
        </button>

        <itfg-client-options-menu [clientId]="client.id"
                                  [isInputClient]="!!clientData"
                                  [sendPasswordBySms]="sendPasswordBySms"
                                  [sendPasswordByEmail]="sendPasswordByEmail"
                                  [openCreateOfferDialog]="openCreateOfferDialog"
                                  [openCreateCreditLimitOfferDialog]="openCreateCreditLimitOfferDialog"
                                  [data]="clientComponentData.profileData"
                                  [isNewItem]="isNewItem"></itfg-client-options-menu>
      </div>
    </div>
  </div>
  <div class="edit-screen-body"
       layout="row"
       layout-wrap
       layout-align="start stretch">
    <div flex-gt-md="33"
         flex-gt-sm="50"
         flex-gt-xs="100"
         flex
         #profileElement>
      <itfg-profile-data-edit #profileComponent
                              [data]="clientComponentData.profileData"
                              [brandList]="brandData"
                              [client]="client"
                              [isNewItem]="isNewItem"
                              (dataChanged)="profileDataChanged($event)"
                              [lastLogin]="lastLogin"
                              [isDirty]="invalidProfileData">
      </itfg-profile-data-edit>
    </div>
    <div flex-gt-md="33"
         flex-gt-sm="50"
         flex-gt-xs="100"
         flex
         #personalElement>
      <itfg-personal-data-edit #personalComponent
                               [data]="clientComponentData.personalData"
                               [client]="client"
                               [isNewItem]="isNewItem"
                               (dataChanged)="personalDataChanged($event)">
      </itfg-personal-data-edit>
    </div>
    <div flex-gt-md="33"
         flex
         #personalIdElement>
      <itfg-personal-id-data-edit #personalIdComponent
                                  [data]="clientComponentData.idCardDataAndAddress"
                                  [client]="client"
                                  [clientId]="client.id"
                                  (dataChanged)="idCardDataAndAddressChanged($event)">
      </itfg-personal-id-data-edit>
    </div>
    <div flex="100"
         #contactElement>
      <itfg-contact-data-edit #contactComponent
                              [client]="client"
                              (dataChanged)="contactDataChanged($event)">
      </itfg-contact-data-edit>
    </div>
    <div flex="100">
      <itfg-risk-indicators-edit [client]="client"
                                 [isNewItem]="isNewItem">
      </itfg-risk-indicators-edit>
    </div>
    <div flex="100"
         #occupationStatusElement>
      <itfg-occupation-status-edit #occupationStatusComponent
                                   [data]="clientComponentData.occupationStatus"
                                   [client]="client"
                                   [isNewItem]="isNewItem"
                                   (dataChanged)="occupationStatusDataChanged($event)">
      </itfg-occupation-status-edit>
    </div>
    <div flex-gt-md="50"
         flex-gt-sm="50"
         flex="100"
         *ngxPermissionsOnly="'USER_BANK_ACCOUNT_READ'"
         #bankAccountsEl>
      <itfg-bank-accounts-data #bankAccountComponentEl
                               [data]="clientComponentData.bankAccounts"
                               [client]="client"
                               [isLoading]="isLoadingData"
                               (dataChanged)="bankAccountsDataChanged($event)"
                               (documentDeleted)="onBankAccountDocumentEvent($event)">
      </itfg-bank-accounts-data>
    </div>
    <div flex-gt-md="50"
         flex-gt-sm="50"
         flex="100"
         *ngxPermissionsOnly="'USER_DOCUMENT_READ'"
         #documentsEl>
      <mat-card>
        <mat-card-content>
          <mat-tab-group (selectedTabChange)="onTabChange($event)">
            <mat-tab>
              <ng-template mat-tab-label>
                <div>Документи на клиента</div>
              </ng-template>
              <div>
                <itfg-document-edit #documentsComponentEl
                                    [data]="clientComponentData.documents"
                                    [client]="client"
                                    (dataChanged)="documentDataChanged($event)"
                                    (deleteClientDocument)="deleteClientDocument($event)">
                </itfg-document-edit>
              </div>
            </mat-tab>
            <mat-tab label="Снимки за самоличност"
                     [disabled]="
                !clientComponentData?.identityDocuments ||
                clientComponentData?.identityDocuments.length === 0
              ">
              <div>
                <itfg-data-table #columnTable
                                 [data]="clientComponentData.identityDocuments"
                                 [columns]="identityDocumentsColumns"
                                 [isClickable]="false">
                  <ng-template itfgDataTableTemplate="createdAt"
                               let-value="value">
                    {{ value | itfgDateFormat }}
                  </ng-template>
                  <ng-template itfgDataTableTemplate="type.name"
                               let-value="value">
                    {{
                    'reports.identityVerification.documentTypeShort.' + value
                    | translate
                    }}
                  </ng-template>
                  <ng-template itfgDataTableTemplate="uploaderInfo"
                               let-value="value">
                    {{ value | documentUploaderInfoFormatter }}
                  </ng-template>
                  <ng-template itfgDataTableTemplate="name"
                               let-value="value">
                    <span matTooltip="{{ value }}"
                          matTooltipPosition="above">
                      {{ value | shortenFileName: 30 }}
                    </span>
                  </ng-template>
                  <ng-template itfgDataTableTemplate="actions"
                               let-value="value"
                               let-row="row"
                               let-column="column">
                    <div>
                      <a flex
                         matSuffix
                         mat-icon-button
                         matTooltip="{{ 'global.download' | translate }}"
                         matTooltipPosition="above"
                         (click)="downloadIdentityDocumentClicked($event, row)"
                         class="input-suffix-button">
                        <mat-icon>file_download</mat-icon>
                      </a>
                    </div>
                  </ng-template>
                </itfg-data-table>
              </div>
            </mat-tab>
          </mat-tab-group>
        </mat-card-content>
      </mat-card>
    </div>
    <div layout="row"
         layout-align="end center"
         flex
         class="padding-bottom">
      <button mat-raised-button
              [disabled]="!enableSaveButton || !clientDataChangesDetected"
              (click)="save()"
              [ngClass]="{ 'changes-detected': clientDataChangesDetected }">
        {{ 'global.save' | translate }}
      </button>
    </div>
  </div>
</div>
